module.exports = __webpack_public_path__ + "img/1475653406.03a670b1.jpg";